import {currentUser} from '@/services/FirestoreService';

interface UserAction {
  name: string;
  uid: string;
  timestamp: Date;
}

/**
 * Current user + timestamp for an audit field (`uploadedBy`/`editedOn`). Throws if
 * unauthenticated; missing displayName falls back to '' unless `requireDisplayName`.
 */
const currentUserAction = ({requireDisplayName = false} = {}): UserAction => {
  const user = currentUser();
  if (!user?.uid) throw new Error('User is not authenticated');
  if (requireDisplayName && !user.displayName) {
    throw new Error(`User displayName is not available (uid ${user.uid})`);
  }
  return {name: user.displayName ?? '', uid: user.uid, timestamp: new Date()};
};

export {currentUserAction};
export type {UserAction};
